import http from "../httpService";
import {getBaseUrl} from "../../config";

export const loginService = data => {
  return http.post(
    `${getBaseUrl()}/login`,
    data
  );
};

export const getPersonRole = () => {
  return http.get(
    `${getBaseUrl()}/person_role`
  );
};

export const roleSwitch = data => {
  return http.post(
    `${getBaseUrl()}/role_switch`,
    data
  );
};